// Infos pers
export const HeaderInfoPers = [
  {
    id: 0,
    label: "Prénom légal",
    value: "personnalInformation.personalInfos.legalFirstName"
  },
  {
    id: 1,
    label: "Nom légal",
    value: "personnalInformation.personalInfos.legalName"
  },
  {
    id: 2,
    label: "Date de naissance",
    value: "personnalInformation.personalInfos.dateOfBirth"
    // isDate: true,
  },
  {
    id: 3,
    label: "Prénom utilisé",
    value: "personnalInformation.personalInfos.firstNameUsed"
  },
  {
    id: 4,
    label: "Pays d'origine",
    value: "personnalInformation.personalInfos.originCountry"
  },
  {
    id: 5,
    label: "Langues parlées",
    value: "personnalInformation.personalInfos.spokenLanguages",
    isArray: true
  },
  {
    id: 6,
    label: "Genre légal",
    value: "personnalInformation.personalInfos.legalGender"
  },
  {
    id: 7,
    label: "Groupes",
    value: "groupsName"
  }
];

// Courriels et téléphones
export const HeaderCourriels = [
  {
    id: 7,
    label: "Courriel de correspondance",
    value: "personnalInformation.emails.personalEmail"
  },
  {
    id: 8,
    label: "Autre courriel",
    value: "personnalInformation.emails.professionalEmail"
  },
  {
    id: 9,
    label: "Téléphone professionnel",
    value: "personnalInformation.emails.professionalPhone"
  },
  {
    id: 10,
    label: "N de poste (professionnel)",
    value: "personnalInformation.emails.professionalPhonePostNumber"
  },
  // {id: 9, label: "Autre courriel", value: "personnalInformation.emails.professionalEmail"},
  {
    id: 11,
    label: "Téléphone personnel",
    value: "personnalInformation.emails.personalPhone"
  },
  {
    id: 12,
    label: "N de poste (personnel)",
    value: "personnalInformation.emails.personalPhonePostNumber"
  }
];

// Adresse
export const HeaderAddress = [
  {
    id: 13,
    label: "Adresse",
    value: "personnalInformation.address.firstAdress"
  },
  {
    id: 14,
    label: "Addresse complémentaire",
    value: "personnalInformation.address.secondAdress"
  }
];
//HEALTH
export const HeaderHealth = [
  {
    id: 16,
    label: "Allergies",
    value: "personnalInformation.healthOptions.allergies.value"
  },
  {
    id: 17,
    label: "Préférences alimentaires",
    value: "personnalInformation.healthOptions.foodPreferences.value"
  }
];
// CLOTHES
export const HeaderClothes = [
  {
    id: 18,
    label: "Tête",
    value: "personnalInformation.clothesOptions.head.value"
  },
  {
    id: 19,
    label: "Haut du corps",
    value: "personnalInformation.clothesOptions.upperBody.value"
  },
  {
    id: 20,
    label: "Bas du corps",
    value: "personnalInformation.clothesOptions.lowerBody.value"
  },
  {
    id: 21,
    label: "Gants",
    value: "personnalInformation.clothesOptions.gloves.value"
  },
  {
    id: 22,
    label: "Chaussures",
    value: "personnalInformation.clothesOptions.shoes.value"
  }
];
// Contact d'urgences
export const HeaderEmergencyContacts = [
  {
    id: 23,
    label: "Nom contact 1",
    value: "personnalInformation.firstEmergencyContact.contactName"
  },
  {
    id: 24,
    label: "Relation avec l'employé 1",
    value: "personnalInformation.firstEmergencyContact.employeeRelationship"
  },
  {
    id: 25,
    label: "Téléphone du contact 1",
    value: "personnalInformation.firstEmergencyContact.contactPhone"
  },
  {
    id: 26,
    label: "Courriel du contact 1",
    value: "personnalInformation.firstEmergencyContact.contactEmail"
  },
  {
    id: 27,
    label: "Nom contact 2",
    value: "personnalInformation.secondEmergencyContact[0].contactName"
  },
  {
    id: 28,
    label: "Relation avec l'employé 2",
    value: "personnalInformation.secondEmergencyContact[0].employeeRelationship"
  },
  {
    id: 29,
    label: "Téléphone du contact 2",
    value: "personnalInformation.secondEmergencyContact[0].contactPhone"
  },
  {
    id: 30,
    label: "Courriel du contact 2",
    value: "personnalInformation.secondEmergencyContact[0].contactEmail"
  }
];

// Emploi
export const HeaderEmploi = [
  {
    id: 131,
    label: "Date d'embauche",
    value: "hiringDate"
    // isDate: true
  },
  {
    id: 132,
    label: "Date d'ancienneté relative",
    value: "emploiSalary.job.seniorityDate"
    // isDate: true
  },
  { id: 133, label: "Poste", value: "poste.title" },
  {
    id: 134,
    label: "Emplacement",
    value: "emplacement.employeeEmplacement",
    isArray: true,
    isArrayOfObject: true,
    attribut: "name"
  },
  {
    id: 135,
    label: "Supérieur hierarchique",
    value: "emploiSalary.hierarchical.username"
  },
  { id: 136, label: "Permissions", value: "emploiSalary.Permission.role" },
  {
    id: 137,
    label: "Profil d'accès",
    value: "accessProfile"
  },
  { id: 138, label: "Numéro de l'employé", value: "numEmployer" }
];

// Périodes d'indisponibilités et départ
export const HeaderIndisponibilites = [
  {
    id: 138,
    label: "Date de fin de poste",
    value: "unavailabilities[0].beginningOfPeriod",
    isDate: true
  },
  {
    id: 139,
    label: "Raisons de départ",
    value: "unavailabilities[0].typeOfDemission"
  },
  {
    id: 140,
    label: "Notes",
    value: "unavailabilities[0].notes"
  }
];

// Parcours professionnel, salaire et avantages
export const HeaderParcours = [
  {
    id: 141,
    label: "Salaire (emploi actuel)",
    value: "salaryData.actualSalary"
  },
  {
    id: 142,
    label: "Salaire (emploi précédent)",
    value: "salaryData.previousSalary"
  },
  {
    id: 143,
    label: "Salaires (historique complet)",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "salary",
    defaultValue: 0
  },
  {
    id: 144,
    label: "Devise",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "devise"
  },
  {
    id: 145,
    label: "Type d'emploi",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "jobType"
  },
  {
    id: 146,
    label: "Taux horaire",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "hourlyRate"
  },
  {
    id: 147,
    label: "Heures par semaine",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "hoursPerWeek"
  },
  {
    id: 148,
    label: "Informations additionnelles",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "additionalInformation"
  },
  {
    id: 149,
    label: "Types d'avantages",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "benefitType"
  },
  {
    id: 150,
    label: "Valeur annuelle",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "benefitValue"
  },
  {
    id: 151,
    label: "Notes",
    value: "salaryAndAdvantages",
    isArray: true,
    isArrayOfObject: true,
    attribut: "benefitesNotes"
  },
  {
    id: 152,
    label: "Emploi actuel",
    value: "emploiCourseData.actualCourseName"
  },
  {
    id: 153,
    label: "Emploi précédent",
    value: "emploiCourseData.previousCourseName"
  },
  {
    id: 154,
    label: "Emplois (historique complet)",
    value: "emploiCourses",
    isArray: true,
    isArrayOfObject: true,
    attribut: "title"
  },
  {
    id: 155,
    label: "Date de démarrage (emploi actuel)",
    value: "emploiCourseData.actualCourseStartDate"
  },
  {
    id: 156,
    label: "Date de démarrage (emploi précédent)",
    value: "emploiCourseData.previousCourseStartDate"
  },
  {
    id: 157,
    label: "Date de fin de poste (emploi précédent)",
    value: "emploiCourseData.previousCourseEndDate"
  },
  {
    id: 158,
    label: "Dates de démarrage (historique complet)",
    value: "emploiCourses",
    isArray: true,
    isArrayOfObject: true,
    attribut: "dateStart"
  }
];

// Vacances
export const HeaderVacances = [
  {
    id: 156,
    label: "Journées de maladie permises par année",
    value: "emploiSalary.holiday.hoursSick"
  },
  {
    id: 157,
    label: "Journées de maladies restantes",
    value: "emploiSalary.holidayRemaining.hoursSick"
  },
  {
    id: 158,
    label: "Journées d'absences permises par année",
    value: "emploiSalary.holiday.hoursMiss"
  },
  {
    id: 159,
    label: "Journées d'absences restantes",
    value: "emploiSalary.holidayRemaining.hoursMiss"
  },
  {
    id: 160,
    label: "Journées de vacances permises par année",
    value: "emploiSalary.holiday.hoursHoliday"
  },
  {
    id: 161,
    label: "Journées de vacances restantes",
    value: "emploiSalary.holidayRemaining.hoursHoliday"
  },
  {
    id: 162,
    label: "Nombre d'heures par jour de travail",
    value: "emploiSalary.holiday.hoursPerDay"
  },
  {
    id: 163,
    label: "Date de renouvellement annuel",
    value: "emploiSalary.holiday.renewalDay"
    // isDate: true,
  }
];

// Note
export const HeaderNote = [
  {
    id: 164,
    label: "Notes",
    value: "notes",
    isArray: true,
    isArrayOfObject: true,
    attribut: "title"
  },
  {
    id: 165,
    label: "Date de création",
    value: "notes",
    isDate: true,
    isArray: true,
    isArrayOfObject: true,
    attribut: "createdAt"
  },
  {
    id: 166,
    label: "Dernière modification",
    value: "notes",
    isDate: true,
    isArray: true,
    isArrayOfObject: true,
    attribut: "updatedAt"
  }
];

// Certifications et formations
export const HeaderCertification = [
  {
    id: 167,
    label: "Certifications",
    value: "certifications",
    isArray: true,
    isArrayOfObject: true,
    attribut: "title"
  },
  {
    id: 168,
    label: "Date d'obtention",
    value: "certifications",
    isDate: true,
    isArray: true,
    isArrayOfObject: true,
    attribut: "obtainedDate"
  },
  {
    id: 169,
    label: "Notes",
    value: "certifications",
    isArray: true,
    isArrayOfObject: true,
    attribut: "note"
  },
  {
    id: 170,
    label: "Alertes",
    value: "certifications",
    isDate: true,
    isArray: true,
    isArrayOfObject: true,
    attribut: "alertDate"
  }
];
// Matériel assigné
export const HeaderMaterial = [
  {
    id: 171,
    label: "Marques",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.brand"
  },
  {
    id: 172,
    label: "Désignation des matériels",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.designation"
  },
  {
    id: 173,
    label: "Détails",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.details"
  },
  {
    id: 174,
    label: "Catégories",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.category"
  },
  {
    id: 175,
    label: "Statuts",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.status"
  },
  {
    id: 176,
    label: "Dates d'assignations",
    value: "attributions",
    isDate: true,
    isArray: true,
    isArrayOfObject: true,
    attribut: "date"
  },
  {
    id: 177,
    label: "Etats",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.state"
  },
  {
    id: 178,
    label: "Numéros d'inventaires",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.numberInventory"
  },
  {
    id: 179,
    label: "Numéros de séries",
    value: "attributions",
    isArray: true,
    isArrayOfObject: true,
    attribut: "material.numberSerie"
  }
];

export const HeaderBankingInformation = [
  {
    id: 180,
    label: "Numéro d’assurance social",
    value: "emploiSalary.BankingAndInsuranceInformation.socialInsuranceNumber"
  },
  {
    id: 181,
    label: "Numéro de transit",
    value: "emploiSalary.BankingAndInsuranceInformation.transitNumber"
  },
  {
    id: 182,
    label: "Numéro d'institution",
    value: "emploiSalary.BankingAndInsuranceInformation.institutionNumber"
  },
  {
    id: 183,
    label: "Numéro de compte",
    value: "emploiSalary.BankingAndInsuranceInformation.accountNumber"
  },
  {
    id: 184,
    label: "Numéro de régime",
    value: "emploiSalary.BankingAndInsuranceInformation.planNumber"
  },
  {
    id: 185,
    label: "Numéro de certificat d'adhérent",
    value: "emploiSalary.BankingAndInsuranceInformation.memberCertificateNumber"
  },
  {
    id: 186,
    label: "Numéro de plan d'assurance",
    value: "emploiSalary.BankingAndInsuranceInformation.insurancePlanNumber"
  },
  {
    id: 187,
    label: "Type de couverture",
    value: "emploiSalary.BankingAndInsuranceInformation.typeCover"
  }
];

export const HeaderDisciplinary = [
  {
    id: 188,
    label: "Titre de l' évènement",
    value: "disciplinaryFollowUp",
    isArray: true,
    isArrayOfObject: true,
    attribut: "eventTitle"
  },
  {
    id: 189,
    label: "Évènement",
    value: "disciplinaryFollowUp",
    isArray: true,
    isArrayOfObject: true,
    attribut: "event"
  },
  {
    id: 190,
    label: "Catégorie",
    value: "disciplinaryFollowUp",
    isArray: true,
    isArrayOfObject: true,
    attribut: "category"
  },
  {
    id: 191,
    label: "Gradation",
    value: "disciplinaryFollowUp",
    isArray: true,
    isArrayOfObject: true,
    attribut: "gradation"
  },
  {
    id: 192,
    label: "Date/Période",
    value: "disciplinaryFollowUp",
    isArray: true,
    isArrayOfObject: true,
    attribut: "datePeriod"
  },
  {
    id: 193,
    label: "Note interne",
    value: "disciplinaryFollowUp",
    isArray: true,
    isArrayOfObject: true,
    attribut: "internalNote"
  },
  {
    id: 195,
    label: "Alerte",
    value: "disciplinaryFollowUp",
    isArray: true,
    isArrayOfObject: true,
    attribut: "alert"
  }
];

// Formations
export const HeaderFormation = [
  {
    id: 196,
    label: "Formations",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "title"
  },
  {
    id: 197,
    label: "Catégories",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "category"
  },
  {
    id: 198,
    label: "Dates",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "date"
  },
  {
    id: 199,
    label: "Heures",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "hours"
  },
  {
    id: 200,
    label: "Formateurs",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "trainer"
  },
  {
    id: 201,
    label: "Notes",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "note"
  },
  {
    id: 202,
    label: "Coûts",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "cost"
  },
  {
    id: 203,
    label: "Admissibilité",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "eligibility"
  },
  {
    id: 204,
    label: "Statut",
    value: "formations",
    isArray: true,
    isArrayOfObject: true,
    attribut: "status"
  }
];
export const dataForListBoxInfoPers = [
  {
    id: 0,
    label: "Informations personnelles",
    data: [...HeaderInfoPers]
  },
  {
    id: 1,
    label: "Courriels et téléphones",
    data: [...HeaderCourriels]
  },
  {
    id: 2,
    label: "Adresse",
    data: [...HeaderAddress]
  },
  {
    id: 3,
    label: "Santé - Allergies et préférences alimentaires",
    data: [...HeaderHealth]
  },
  {
    id: 4,
    label: "Taille des vêtements",
    data: [...HeaderClothes]
  },
  {
    id: 5,
    label: "Contacts d’urgences",
    data: [...HeaderEmergencyContacts]
  }
];

export const dataForListBoxEmploi = [
  {
    id: 0,
    label: "Emploi",
    data: [...HeaderEmploi]
  },
  {
    id: 1,
    label: "Départ",
    data: [...HeaderIndisponibilites]
  },
  {
    id: 2,
    label: "Parcours professionnel, salaire et avantages",
    data: [...HeaderParcours]
  },
  // {
  //   id: 3,
  //   label: "Vacances",
  //   data: [...HeaderVacances],
  // },
  {
    id: 4,
    label: "Suivis disciplinaires",
    data: [...HeaderDisciplinary]
  }
];

export const dataForListBoxCertifications = [
  {
    id: 0,
    label: "Notes et notes RH",
    data: [...HeaderNote]
  },
  {
    id: 1,
    label: "Certifications",
    data: [...HeaderCertification]
  },
  {
    id: 2,
    label: "Formations",
    data: [...HeaderFormation]
  }
];

export const dataForListBoxMaterial = [
  {
    id: 0,
    label: "Matériel assigné",
    data: [...HeaderMaterial]
  }
];
export const dataListForBankingInformation = [
  {
    id: 0,
    label: "Informations bancaires et d'assurance",
    data: [...HeaderBankingInformation]
  }
];

export const AllToHeaderExpectBanking = [
  // Infos pers
  ...HeaderInfoPers,
  // Courriels et téléphones
  ...HeaderCourriels,
  // Adresse
  ...HeaderAddress,
  //Santé - Allergies et préférences alimentaires
  ...HeaderHealth,
  // Taille des vêtements
  ...HeaderClothes,
  // Contact d'urgences
  ...HeaderEmergencyContacts,
  // Emploi
  ...HeaderEmploi,
  // Périodes d'indisponibilités et départ
  ...HeaderIndisponibilites,
  // Parcours professionnel, salaire et avantages
  ...HeaderParcours,
  // Vacances
  // ...HeaderVacances,
  // Note
  ...HeaderNote,
  // Certifications et formations
  ...HeaderCertification,
  // Matériel assigné
  ...HeaderMaterial,
  // Suivis disciplinaires
  ...HeaderDisciplinary,
  //Formations
  ...HeaderFormation
];

export const AllToHeader = [
  ...AllToHeaderExpectBanking,
  ...HeaderBankingInformation
];
